export const { REACT_APP_BASE_URL, REACT_APP_SECRET, REACT_APP_URL } =
    process.env;
